import React, {useContext, useEffect, useState} from 'react';
import {companyService} from '../../../services';
import {Modal, notification, Button, Table, Row, Col} from 'antd';
import Spinner from "../../spinner";
import i18n from '../../../i18n';
import {getWithTranslate} from "../../../helpers/doc_type.helper";
import {legalEntityService} from "../../../services/legal-entity.service";
import {fileHelper} from "../../../helpers/file.helper";

export default function ModalLegalEntityFullInfo({ legalEntityId, isShow, setIsShow }) {
  const legalEntityDataAliases = getWithTranslate('legalEntityDataAliases');

  const [loading, setLoading] = useState(true);

  const [legalEntityInfo, setLegalEntityInfo] = useState([]);

  const [columns, setColumns] = useState([
      {
          title: '',
          dataIndex: 'name',
          key: 'name',
      },
      {
          title: '',
          key: 'data',
          render: (record) => {
              function isUrl(string) {
                  let regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
                  return regexp.test(string);
              }

              if (isUrl(record.data)) {
                  return (
                      <React.Fragment>
                          <a href={record.data} target="_blank" rel="noopener noreferrer" className="active">{i18n.t('main.buttons.open')}</a>
                      </React.Fragment>
                  );
              } else {
                  if (record.data === 0 || record.data === 1) {
                      return record.data ? i18n.t('main.yes') : i18n.t('main.no');
                  }
                  return record.data
              }
          }
      },
  ]);

  useEffect(() => {
        if (isShow) {
            setLoading(true);

            companyService.getLegalEntityFullInfo(legalEntityId)
                .then((response) => {
                    let data = [];
                    Object.keys(response).forEach((element) => {
                        if (response[element] !== null && response[element] !== '') {
                            if (typeof legalEntityDataAliases[element] !== 'undefined')
                            data.push(
                                {
                                    name: legalEntityDataAliases[element],
                                    data: response[element]
                                }
                            );
                        }
                    });

                    Object.keys(response.Docs).forEach((element) => {
                        if (response.Docs[element] !== null) {
                            let document = response.Docs[element];
                            if (typeof legalEntityDataAliases[document.Name] !== 'undefined') {
                                data.push(
                                    {
                                        name: legalEntityDataAliases[document.Name],
                                        data: document.Url
                                    }
                                );
                            } else if (document.ReadableName) {
                                data.push(
                                    {
                                        name: document.ReadableName,
                                        data: document.Url
                                    }
                                );
                            }
                        }
                    });

                    setLegalEntityInfo(data);
                    setLoading(false);
                })
                .catch((err) => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getOrders'),
                        description: err
                    });
                    setLoading(false);
                    setIsShow(false);
                });
        }

  }, [isShow]);

  const handleDownloadDocsArchive = (id) => {
      legalEntityService.getLegalEntityDocsArchive({id})
          .then(resp => {
              fileHelper.downloadFileBase64(resp, `${i18n.t('modals.modalLegalEntityFullInfo.fields.legalEntityDocsArchive.title')}.zip`)
          })
          .catch(err => {
              notification.error({
                  message: i18n.t('components.notification.titles.getLegalEntityDocsArchive'),
                  description: err
              });
          });
  };

  return (
      <Modal
          title={i18n.t('modals.modalLegalEntityFullInfo.title')}
          cancelText={i18n.t('main.buttons.close')}
          className="modal-window"
          align={null}
          visible={isShow}
          onCancel={() => {
              setIsShow(false);
          }}
          footer={null}
      >
          <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
              <Table
                  columns={columns}
                  dataSource={legalEntityInfo}
                  rowKey="name"
                  pagination={false}
                  size="small"
                  showHeader={false}
              />
          </Spinner>
          <Row gutter={[10, 10]}>
              <Col offset={8} span={8}>
                  <Button
                      htmlType="button"
                      key="submitPrev"
                      onClick={() => handleDownloadDocsArchive(legalEntityId)}
                      type="primary"
                      size="large"
                      style={{width: '100%'}}
                  >
                    {i18n.t('modals.modalLegalEntityFullInfo.buttons.downloadDocsArchive')}
                  </Button>
              </Col>
          </Row>
      </Modal>
  );

}
